module.exports = __webpack_public_path__ + "static/media/individual-over.6110c96a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/individual-over.svg
// module id = 344
// module chunks = 0